"use client"

import styled from "@emotion/styled"
import { Typography } from "@mui/material"
import { CustomBreadcrumbs } from "ui"
import Container from "ui/Container"
import { extractProperty, getBreadCrumbs, transformProperties } from "utils"
import DynamicTitle from "../Common/DynamicTitle"
import RavKavServiceStationBlock from "./RavKavServiceStationBlock"

const StyledDiv = styled.div`
  width: 100%;
`

const StyledBreadcrumbsContainer = styled.div`
  padding: 0 16px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    padding: 0;
  }
`

const StyledContentDiv = styled.div`
  padding-top: 32px;
  padding-bottom: 24px;
  h3 {
    ${({ theme }) => theme.breakpoints.up("md")} {
      padding-bottom: 48px;
    }
  }
`

type Props = {
  data: any
  locale: string
}

const KavStations = ({ data, locale }: Props) => {
  const parsedData = data?.page?.properties || []
  const { blocks } = transformProperties(parsedData)
  const breadCrumbs = getBreadCrumbs(data, locale)

  const ravKavServiceStation = blocks?.blocks?.find(
    (block: any) => block.blockType === "ravKavServiceStation",
  )
  const dynamicTitleBlock = blocks?.blocks?.find(
    (block: any) => block.blockType === "adynamicTitleAndContant",
  )

  const title = extractProperty(ravKavServiceStation, "title")

  return (
    <StyledDiv>
      <Container paddingMobile>
        <StyledBreadcrumbsContainer>
          <CustomBreadcrumbs breadcrumbs={breadCrumbs} />
        </StyledBreadcrumbsContainer>
      </Container>
      {dynamicTitleBlock && (
        <DynamicTitle data={dynamicTitleBlock} paddingBottom={false} />
      )}
      <Container paddingMobile>
        <StyledContentDiv>
          <Typography variant="h3">{title}</Typography>
        </StyledContentDiv>
      </Container>
      {ravKavServiceStation && (
        <RavKavServiceStationBlock data={ravKavServiceStation} />
      )}
    </StyledDiv>
  )
}

export default KavStations
